import React from 'react';
import { pxToRem } from '@withjoy/joykit/theme';
import { Box, TextV2 as Text } from '@withjoy/joykit';

export type FilterFacetProps = Readonly<{
  title: string;
  description?: string;
  children: React.ReactNode;
}>;

export const FilterFacet: React.FC<FilterFacetProps> = ({ title, description, children }) => {
  return (
    <Box>
      <Text
        typographyVariant="hed2"
        marginBottom={description ? 2 : pxToRem(20)}
      >
        {title}
      </Text>
      {description && (
        <Text
          color="mono10"
          typographyVariant="body1"
          marginBottom={pxToRem(24)}
        >
          {description}
        </Text>
      )}
      {children}
    </Box>
  );
};
